module.exports = __webpack_public_path__ + "media/src/images/placeholders/position-1d67953c36f8164861614500c59ba723.png";